module.exports = __webpack_public_path__ + "img/logo.999c442b.png";